import React from 'react';
import {
  Button,
  Dialog,
  ButtonGroup,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { setData } from '../../../redux';
import { sortByDate } from '../../../../helperFunctions';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import DeinstalledDevicesList from './DeinstalledDevicesList';
import DeinstalledDeviceInput from './DeinstalledDeviceInput';

export default () => {
  const data = useSelector(state => state.tasks.data);
  const startedTaskId = useSelector(state => state.tasks.taskStarted.taskId);
  const task = data.tasks.find(x => x.id === startedTaskId);

  if (!task) return null;
  const taskIndex = data.tasks.indexOf(data.tasks.find(x => x.id === task.id));
  const { troubleProtocol } = task;
  const { isDeinstalledDevicesDialogOpen, allClientDevices } = troubleProtocol;
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const smallerFontSize = width <= 500 ? '3.5vw' : '18px';

  const setIsOpen = isOpen => {
    const updatedTroubleProtocol = { ...troubleProtocol };
    updatedTroubleProtocol.isDeinstalledDevicesDialogOpen = isOpen;

    const updatedTask = {
      ...task,
      troubleProtocol: updatedTroubleProtocol,
    };

    const updatedTasks = [...data.tasks];
    updatedTasks.splice(taskIndex, 1, updatedTask);

    dispatch(
      setData({
        ...data,
        tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
      })
    );
  };

  const getDevicesToMap = () => {
    return allClientDevices
      ? allClientDevices.filter(x => x.quantity !== 0 && x.serialNumber !== null)
      : [];
  };

  return (
    <Dialog open={isDeinstalledDevicesDialogOpen} fullScreen>
      <div>
        <ButtonGroup style={{ position: 'sticky', width: '100%', top: '0', zIndex: '100' }}>
          <Button
            onClick={() => {
              setIsOpen(false);
            }}
            variant="contained"
            style={{ width: '100%' }}
          >
            <Typography gutterBottom component="span" style={{ fontSize: smallerFontSize }}>
              Затвори
            </Typography>
          </Button>
        </ButtonGroup>
        <DeinstalledDevicesList />
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    fontSize: smallerFontSize,
                    paddingRight: '1px',
                    lineHeigth: '1.1',
                  }}
                  size="small"
                >
                  Име
                </TableCell>
                <TableCell
                  style={{
                    fontSize: smallerFontSize,
                    paddingRight: '1px',
                    lineHeigth: '1.1',
                  }}
                  size="small"
                >
                  Сер. номер
                </TableCell>
                <TableCell
                  style={{
                    fontSize: smallerFontSize,
                    paddingRight: '1px',
                    lineHeigth: '1.1',
                  }}
                  size="small"
                >
                  Кол.
                </TableCell>

                <TableCell
                  style={{
                    fontSize: smallerFontSize,
                    lineHeigth: '1.1',
                  }}
                  size="small"
                >
                  Изп. Кол.
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getDevicesToMap().map(x => (
                <TableRow key={x.serialNumber || x.materialId}>
                  <TableCell
                    style={{
                      fontSize: smallerFontSize,
                      paddingRight: '1px',
                      lineHeigth: '1.1',
                    }}
                    size="small"
                  >
                    {x.type}
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: smallerFontSize,
                      paddingRight: '1px',
                      lineHeigth: '1.1',
                    }}
                    size="small"
                  >
                    {x.serialNumber}
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: smallerFontSize,
                      paddingRight: '1px',
                      lineHeigth: '1.1',
                    }}
                    size="small"
                  >
                    {x.quantity}
                  </TableCell>

                  <TableCell
                    style={{
                      fontSize: smallerFontSize,
                      lineHeigth: '1.1',
                    }}
                    size="small"
                  >
                    <DeinstalledDeviceInput material={x} {...{ smallerFontSize }} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </Dialog>
  );
};
